(function() {
	'use strict';
	angular.module('app.setup')
		.controller('reportCardParams', reportCardParams);

	reportCardParams.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', 'tableService', 'leanFilterService',
		'tableRenderService', 'reportCardParamsService', 'storeService'];
	function reportCardParams($scope, $rootScope, $timeout, $uibModal, tableService, leanFilterService,
			tableRenderService, reportCardParamsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'ViewReportCardParams';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;

		vm.useSiteSwitcher = true;
		vm.reportTitle = 'Report Card Parameters';
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddReportCardParameter = vm.isAdmin;
		vm.addAddReportCardParameter = addAddReportCardParameter;
		vm.deleteReportCardParameter = deleteReportCardParameter;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Report Card Parameters';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		init();

		var columns = [
			{
				'id': 'name',
				'display': 'Parameter Name',
				'renderer': tableRenderService.inlineEditWithoutTooltip,
				'deleteFunction': 'deleteReportCardParameter',
				'requiredPermission': 'adminOrUser',
				'allowBlank': false,
				'width': 400
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: adminConfig.factory.id + '/ReportCardParameters',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			isGlobalReportSetting:true
		};

		function init() {
			$scope.filterService.clearFilters();
		}

		function addAddReportCardParameter() {
			var reportCardParamFormScope = $scope.$new();
			reportCardParamFormScope.selected = {};
			var opts = {
				scope: reportCardParamFormScope,
				templateUrl: '/application/f/setup/factory/general/report-card-params-form.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);

			reportCardParamFormScope.save = function() {
				var saveObj = {};
				saveObj['name'] = reportCardParamFormScope.selected.name;
				reportCardParamsService.addReportCardParameter(saveObj, adminConfig.factory.id)
					.then(function(message) {
						var isSuccessful = (message == 'Report card parameter created successfully');
						$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
						if (isSuccessful) {
							$scope.$broadcast('reloadTable');
						}
					});
				instance.close();
				reportCardParamFormScope.$destroy();
			};

			reportCardParamFormScope.close = function() {
				instance.close();
				reportCardParamFormScope.$destroy();
			};

			reportCardParamFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					reloadTable();
				}
				instance.close();
				reportCardParamFormScope.$destroy();
			};
		}

		function deleteReportCardParameter(reportCardParameterNdx) {
			var confirmScope = $scope.$new();
			confirmScope.reportCardParameterNdx = reportCardParameterNdx;
			confirmScope.additionalText = 'delete this report card parameter';
			confirmScope.buttonText = 'Delete';

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();
				reportCardParamsService.deleteReportCardParameter(reportCardParameterNdx, adminConfig.factory.id).then(function(message) {
					var isSuccessful = (message == 'Report card parameter deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						$scope.$broadcast('reloadTable');
					}
				});
			};
		}
		init();
	}
})();
